import { Link } from 'react-router-dom';
import { featuredCollections, movies } from '@/mocks/movies';

export default function FeaturedCollections() {
  const getMoviesForCollection = (movieIds: string[]) => {
    return movies.filter((m) => movieIds.includes(m.id));
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="mb-6">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900">
            精选合集
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            为你精心策划的主题影片合辑
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featuredCollections.map((collection) => {
            const collectionMovies = getMoviesForCollection(collection.movieIds);
            return (
              <Link
                key={collection.id}
                to="/category/all"
                className="group block rounded-lg overflow-hidden bg-background-50 hover:bg-background-100 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-40 overflow-hidden">
                  <img
                    src={collection.image}
                    alt={collection.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute bottom-3 left-3 right-3">
                    <h3 className="text-sm font-semibold text-white">
                      {collection.title}
                    </h3>
                  </div>
                </div>
                <div className="p-3">
                  <p className="text-xs text-foreground-500 mb-2">
                    {collection.description}
                  </p>
                  <div className="flex items-center gap-1 flex-wrap">
                    {collectionMovies.map((m) => (
                      <span
                        key={m.id}
                        className="inline-block px-2 py-0.5 rounded text-xs bg-background-100 text-foreground-600"
                      >
                        {m.title}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}